import { z } from 'zod';

export const messageSchema = z.object({
  role: z.enum(['user', 'system']),
  content: z.string(),
});

export const chatRequestSchema = z.object({
  messages: z.array(messageSchema),
});

export const chatResponseSchema = z.object({
  answer: z.string(),
});

export type Message = z.infer<typeof messageSchema>;
export type ChatRequest = z.infer<typeof chatRequestSchema>;
export type ChatResponse = z.infer<typeof chatResponseSchema>;
